import { render, staticRenderFns } from "./PostulantExistingUser.vue?vue&type=template&id=c837643a&scoped=true&"
import script from "./PostulantExistingUser.vue?vue&type=script&lang=js&"
export * from "./PostulantExistingUser.vue?vue&type=script&lang=js&"
import style0 from "./PostulantExistingUser.vue?vue&type=style&index=0&id=c837643a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c837643a",
  null
  
)

export default component.exports